<template>
	<div>
		<select v-model="view" class="progress-blocks__select" v-if="$mq === 'lg'">
			<option value="months">
				Months
			</option>
			<option value="topics">
				Topics
			</option>
			<option value="types">
				Types
			</option>
		</select>
		<div class="progress-blocks">
			<div
				@click="clearFilters"
				class="progress-block"
				:class="{'progress-block--active':active === 0}">
					<div class="progress-block__top">
						<h3 class="progress-block__top__title">All tasks</h3>
					</div>
					<BrickFooter
						:tasks="tasks">
					</BrickFooter>
			</div>
			<div class="progress-blocks__row progress-blocks__row--weeks" v-if="view === 'weeks'">
				<div
					:key="index"
					v-for="(week, index) in getTaskWeeks(tasks)"
					class="progress-block">
					<div class="progress-block__top">
						<h3 class="progress-block__top__title">Week {{week.week}}</h3>
					</div>
					<div class="progress-block__footer">
						<div class="progress-block__footer__progress">
							<Progress
								:tasks="getWeekTasks(week, tasks)">
							</Progress>
						</div>
					</div>
				</div>
			</div>
			<div class="progress-blocks__row progress-blocks__row--topics" v-if="view === 'topics'">
				<div
					@click="setFilters('topic', index); setActive(index + 1)"
					:key="topic.id"
					v-for="(topic, index) in topics"
					class="progress-block"
					:class="{'progress-block--active':active === index + 1}">
					<div class="progress-block__top">
						<h3 class="progress-block__top__title">{{topic.title}}</h3>
					</div>
					<BrickFooter
						:tasks="getTopicTasks(tasks, index)">
					</BrickFooter>
				</div>
			</div>
			<div class="progress-blocks__row progress-blocks__row--types" v-if="view === 'types'">
				<div
					@click="setFilters('type', type); setActive(index + 1)"
					:key="index"
					v-for="(type, index) in getTaskTypes(tasks)"
					class="progress-block"
					:class="{'progress-block--active':active === index + 1}">
					<div class="progress-block__top">
						<h3 class="progress-block__top__title">{{type}}</h3>
					</div>
					<BrickFooter
						:tasks="getTypeTasks(tasks,type)">
					</BrickFooter>
				</div>
			</div>
			<div class="progress-blocks__row progress-blocks__row--months" v-if="view === 'months'">
				<div
					@click="setFilters('month', month); setActive(index + 1)"
					:key="index"
					v-for="(month, index) in getTaskMonths(tasks)"
					class="progress-block"
					:class="{'progress-block--active':active === index + 1}">
					<div class="progress-block__top">
						<h3 class="progress-block__top__title">{{month.name}}</h3>
					</div>
					<BrickFooter
						:tasks="getMonthTasks(month, tasks)">
					</BrickFooter>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import DateService from '@/services/DateService'
import PlanningService from '@/services/PlanningService'
import Progress from '@/components/Progress.vue'
import BrickFooter from '@/components/structure/BrickFooter'
export default {
	components: {
		Progress,
		BrickFooter
	},
	props: {
		tasks: Array,
		topics: Array
	},
	data () {
		return {
			active: 0,
			view: 'topics'
		}
	},
	methods: {
		clearFilters () {
			this.$emit('clearFilters')
			this.setActive(0)
		},
		setActive (index) {
			this.active = index
		},
		setFilters (type, key) {
			this.$emit('setFilters', type, key)
		},
		// Weeks
		getTaskWeeks (tasks) {
			return DateService.getTaskWeeks(tasks)
		},
		getWeekTasks (week, tasks) {
			return PlanningService.getWeekTasks(week, tasks)
		},
		// Months
		getTaskMonths (tasks) {
			return DateService.getTaskMonths(tasks)
		},
		getMonthTasks (month, tasks) {
			return PlanningService.getMonthTasks(month, tasks)
		},
		// Topics
		getTopicTasks (tasks, topicIndex) {
			return PlanningService.getTopicTasks(tasks, topicIndex)
		},
		// Types
		getTaskTypes (tasks) {
			return PlanningService.getTaskTypes(tasks)
		},
		getTypeTasks (tasks, type) {
			return PlanningService.getTypeTasks(tasks, type)
		}
	},
	computed: {
	},
	watch: {
		view () {
			this.clearFilters()
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/styles/components/_progress-blocks.scss";
</style>
